<template>
  <div class="c-action-links">
    <div class="c-action-links__item">
      <Teleport to="#js-q2e_mockup_tool_generate_pdf_teleport_slot">
        <app-action-links-generate-p-d-f @generate-pdf="generatePdf($event)" />
      </Teleport>
      <app-action-links-generate-p-d-f @generate-pdf="generatePdf($event)" />
    </div>
    <div class="c-action-links__item">
      <a
        id="js-mockup_tool_send_1004_trigger"
        class="c-action-links__btn c-btn hidden"
        href="#"
        @click="sendForReal($event)"
      >
        jetzt absenden
      </a>
      <a
        class="c-action-links__btn c-btn"
        href="#js-come_back_later"
        @click="sendLink()"
      >
        später weiterdenken
      </a>
    </div>
    <div class="c-action-links__item">
      <a
        class="c-action-links__btn c-action-links__btn--highlight c-btn"
        href="#form-1946"
      >
        Idee übermitteln
      </a>
      <a
        id="js-mockup_tool_send_1005_trigger"
        class="c-action-links__btn c-btn hidden"
        href="#"
        @click="sendForReal1005($event)"
      >
        jetzt absenden
      </a>
    </div>
  </div>

</template>

<script>

import AppActionLinksGeneratePDF from '@/components/AppActionLinksGeneratePDF.vue';

export default {
  name: 'AppActionLinks',
  components: {AppActionLinksGeneratePDF},
  emits: ['generate-pdf', 'send-link', 'send-contact-form', 'copy-shortcode'],
  mounted() {
    document.addEventListener('click', this.handleDummyClick, false);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDummyClick, false);
  },
  methods: {
    handleDummyClick(event) {
      // If the clicked element doesn't have the right selector, bail
      if (!event.target.matches('.js-submit_form_1004_dummy') && !event.target.matches('.js-submit_form_1005_dummy') && !event.target.closest('#js-copy_shortcode_dummy')) return;

      // Don't follow the link
      event.preventDefault();

      if (event.target.matches('.js-submit_form_1004_dummy')) {
        document.getElementById('js-mockup_tool_send_1004_trigger').click();
      }

      if (event.target.matches('.js-submit_form_1005_dummy')) {
        document.getElementById('js-mockup_tool_send_1005_trigger').click();
      }

      if (event.target.closest('#js-copy_shortcode_dummy')) {
        this.copyShortcode(event);
      }
    },
    generatePdf(event) {
      event.preventDefault();
      this.$emit('generate-pdf');
    },
    copyShortcode(event) {
      event.preventDefault();
      this.$emit('copy-shortcode')
    },
    sendForReal(event) {
      event.preventDefault();
      this.$emit('send-link');
      // eslint-disable-next-line
      $('.js-submit_form_1004').click();
    },
    sendForReal1005(event) {
      event.preventDefault();
      this.$emit('send-contact-form');
      // eslint-disable-next-line
      $('.js-submit_form_1005').click();
    },
    sendLink() {
      this.$emit('send-link');
    }
  }
}
</script>

<style lang="less">
.c-action-links {
  display: flex;

  &__item {
    margin: 0 2.5px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &__btn {
    border: 1px solid #0375a6;
    border-width: 1px !important;
    padding: 0.5rem 1rem;
    display: inline-block;
    
    &--highlight {
      border-color: #3f9893;
      background-image: linear-gradient(to right, #d4bf79 0%, #d4af37 15%, #d4bf79 50%, #3f9893 50%);
      color: #fff;

      &:hover,
      &:focus,
      &:focus-visible {
        border-color: #d4af37 !important;
      }
    }
  }
}

.c-mockup-tool .c-action-links__hidden-in-mockuptool {
    display: none;
  }
</style>